const features = [
  {
    icon: 'ri-notification-3-line',
    color: 'bg-primary-500',
    title: '漫画更新提醒',
    desc: '订阅你关注的漫画，最新话更新后第一时间收到提醒，绝不错过任何精彩章节。',
  },
  {
    icon: 'ri-send-plane-fill',
    color: 'bg-accent-500',
    title: '最新话推送',
    desc: '主动推送最新话内容，无需反复刷新，打开即可阅读更新进度与最新章节。',
  },
  {
    icon: 'ri-bar-chart-box-line',
    color: 'bg-secondary-500',
    title: '连载进度查询',
    desc: '清晰展示连载状态、总话数与最新章节，一眼掌握每部作品的整体进度。',
  },
  {
    icon: 'ri-calendar-check-line',
    color: 'bg-primary-500',
    title: '漫画更新日历',
    desc: '以日历形式总览每周更新安排，提前规划你的追更时间，追更更从容。',
  },
];

export default function Features() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mb-10 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-sm font-medium text-primary-700">
          <i className="ri-sparkling-2-fill" /> 核心功能
        </span>
        <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">
          一站式漫画追更工具
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
          从更新提醒到连载进度，从更新日历到追更社区，漫迹帮你把追更的每一件事都安排得明明白白。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {features.map((f) => (
          <div
            key={f.title}
            className="rounded-lg border border-background-200 bg-background-100 p-6 transition-colors hover:border-primary-300"
          >
            <span className={`flex h-12 w-12 items-center justify-center rounded-lg ${f.color} text-xl text-background-50`}>
              <i className={f.icon} />
            </span>
            <h3 className="mt-4 text-base font-bold text-foreground-950">{f.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}